import Request from "../lib/request";
import { PROJECT_ID } from "../constants/storageKeys";
import {
  ACCOUNT_TITLES_API,
  PROJECTS_API,
  SUB_ACCOUNT_TITLES_API
} from "../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;

export const remove = (accountTitleId, id) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "delete",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${ACCOUNT_TITLES_API}/${accountTitleId}/${SUB_ACCOUNT_TITLES_API}/${id}`,
    needToken: true
  });
};

export const store = (accountTitleId, data) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${ACCOUNT_TITLES_API}/${accountTitleId}/${SUB_ACCOUNT_TITLES_API}`,
    needToken: true,
    data: data
  });
};

export const update = (accountTitleId, id, data) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${ACCOUNT_TITLES_API}/${accountTitleId}/${SUB_ACCOUNT_TITLES_API}/${id}`,
    needToken: true,
    data: data
  });
};
